import { CircularProgress, Grid } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { useNotification } from '../../helpers/Notification';
import { ModalComponent } from '../../widgets';
import { SETTINGS_LAYOUT } from '../../widgets/template/TemplateReducer';
import BotonComponent from '../dashboard/components/BotonNuevo';
import { saveCarnetAction, setActivoCarnetAction } from './CarnetAction';
import CarnetAjustesView from './CarnetAjustes';
import useCarnetHook from './CarnetHook';
import jsonStyles from './StylesCarnet.json';

const CarnetView = () => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const { perfiles, all, activo, entidad, params, loading } = useCarnetHook();

  const templateStore = Redux.useSelector((state) => state.template);

  const [openModalForm, setOpenModalForm] = React.useState(false);

  React.useEffect(() => {
    if (templateStore.settings.openSidebar) {
      dispatch({
        type: SETTINGS_LAYOUT,
        payload: {
          ...templateStore.settings,
          openSidebar: false,
        },
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activo]);

  const perfilesArray = () => {
    const lista = perfiles.filter(
      (perfil) => !all.some((carnet) => carnet.perfil.id === perfil.id),
    );

    return lista.map((el) => (
      <BotonComponent
        text={el.nombre}
        blue
        mr={2}
        mb={2}
        click={async () => {
          await saveCarnetAction(
            { dispatch, notify },
            null,
            {
              idEntidad: entidad.id,
              idPerfil: el.id,
              nombre: el.nombre,
              ...jsonStyles,
            },
            params,
          );
        }}
      />
    ));
  };

  return (
    <Grid container spacing={1}>
      <Grid
        item
        md={12}
        sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
      >
        <BotonComponent
          click={async () => {
            await setActivoCarnetAction(dispatch, null);
            setOpenModalForm(true);
          }}
          green
          mr={2}
          addIcon
        />

        {all.map((el) => {
          return (
            <BotonComponent
              text={el.nombre}
              mr={2}
              blue={activo?.id !== el.id}
              purple={activo?.id === el.id}
              click={() => setActivoCarnetAction(dispatch, el)}
            />
          );
        })}
      </Grid>
      <Grid item md={12}>
        {loading ? (
          <center>
            <CircularProgress size="3rem" />
          </center>
        ) : (
          activo && <CarnetAjustesView />
        )}
      </Grid>
      {/* <Grid item md={4}>
        <ListadoCarnet setOpenModalForm={(value) => setOpenModalForm(value)} />
      </Grid> */}

      <ModalComponent
        id="modalFormCarnet"
        title="Nuevo carnet"
        open={openModalForm}
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        {perfilesArray()}
      </ModalComponent>
    </Grid>
  );
};

export default CarnetView;
